import React, { PropTypes } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import DataService from '../../lib/DataService';
import PostsList from './PostsList';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';
import CurrentRoleActions from '../../actions/CurrentRoleActions';


let POSTS_LIMIT_PER_PAGE = 10;

export default class StudentPostsIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      studentId: parseInt(props.params.studentId),
      studentName: '',
      studentAvatar: '',

      studentPosts: [],

      userRoleInfo: CurrentRoleStore.getCurrentRole(),

      hasMore: true
    };
    // bind this
    this.loadStudentPosts = this.loadStudentPosts.bind(this);
    this.loadStudent = this.loadStudent.bind(this);
    this.onUserRoleChange = this.onUserRoleChange.bind(this);
    this.onScrollToBottom = this.onScrollToBottom.bind(this);
    this.onDestroyPost = this.onDestroyPost.bind(this);
    this.onUntagPost = this.onUntagPost.bind(this);
    this._profileHeaderView = this._profileHeaderView.bind(this);
    this._postsListView = this._postsListView.bind(this);
  }

  componentWillMount() {
    this.isLoading = false;
    this.loadStudent(this.state.studentId);

    CurrentRoleStore.addChangeListener(this.onUserRoleChange);

    // callback if userRoleInfo is undefined
    if (!this.state.userRoleInfo) {
      let classId = this.props.localtion.query.classId;
      let criteria = classId ? {classId: classId} : {studentId: this.state.studentId};
      CurrentRoleActions.findAndSetCurrentUserRole(criteria);
    }
  }

  componentWillUnmount(){
      CurrentRoleStore.removeChangeListener(this.onUserRoleChange);
  }

  componentWillReceiveProps(newProps) {
    let newStudentId = parseInt(newProps.params.studentId);
    if (newStudentId != this.state.studentId) {
      this.isLoading = false;
      this.setState({
        studentId: newStudentId,
        studentName: '',
        studentAvatar: '',
        studentPosts: [],

        hasMore: true
      });
      this.loadStudent(newStudentId);
    }
  }

  // Tools
  // Loading posts with conditions, all logics are depends on @data instead of this.state
  // @actionAfterLoad: ['append', 'insert']
  loadStudentPosts(studentId, data, actionAfterLoad = 'append') {
    if (this.isLoading)
      return;

    this.isLoading = true;
    DataService.getStudentPosts(studentId, data).then((response) => {
      console.log(response)
      response.forEach((post)=>{
        post.author_name = SharedTools.addRoleName(post.role, post.author_name);
      })
      this.state.studentPosts = actionAfterLoad === 'append' ? this.state.studentPosts.concat(response) : response.concat(this.state.studentPosts);
      if (response.length < POSTS_LIMIT_PER_PAGE)
        this.state.hasMore = false;
      this.setState({
        hasMore: this.state.hasMore
      })
      this.isLoading = false;
    }, (response) => {
      // error response: {status: XXX, errorMessage: {errors: [{message: "Class not found", code: 41}]}}
    }).catch((error) => {
      // catch any error above block ('then' block)
    });
  }

  // Loading student info
  loadStudent(studentId) {
    DataService.getOneStudentInfo(studentId).then((response) => {
      this.setState({
        studentName: response.full_name,
        studentAvatar: response.avatar_url
      })
    }, (response) => {
      // error response: {status: XXX, errorMessage: {errors: [{message: "Class not found", code: 41}]}}
    }).catch((error) => {
      // catch any error above block ('then' block)
    });
  }

  // Events
  onUserRoleChange() {
    this.setState({
      userRoleInfo: CurrentRoleStore.getCurrentRole()
    });
  }

  onScrollToBottom(page) {
    let requestData = {limit: POSTS_LIMIT_PER_PAGE}
    let postCount = this.state.studentPosts.length;
    if (postCount > 0) {
      requestData.to_date = new Date(this.state.studentPosts[postCount - 1].record_date).getTime() / 1000;
    }

    if (this.state.hasMore)
      this.loadStudentPosts(this.state.studentId, requestData);
  }

  onDestroyPost(postId) {
    let index = this.state.studentPosts.findIndex((post) => post.id === postId);
    if (index >= 0) {
      this.state.studentPosts.splice(index, 1);
      this.setState({
        studentPosts: this.state.studentPosts
      });
    }
  }

  onUntagPost(postId) {
    let posts = this.state.studentPosts;
    posts = posts.filter(function(post){
      return post.id != postId
    })
    this.setState({
      studentPosts: posts
    })
  }

  // Views
  _profileHeaderView() {
    return (
      <div className="profile-header">
        <div className="place-holder"></div>
        <div className="student-avatar">
          <img className="custom-avatar" src={this.state.studentAvatar ? SharedTools.getThumbImageUrl(this.state.studentAvatar) : ""} />
        </div>
        <div className="student-name">{this.state.studentName}</div>
      </div>
    )
  }

  _postsListView() {
    let loaderDom = <div className="scroll-loader">正在读取新鲜事 ...</div>;
    return (
      <InfiniteScroll
        pageStart={0}
        loadMore={this.onScrollToBottom}
        hasMore={this.state.hasMore}
        loader={loaderDom}
        useWindow={true}
        className="infinite-scroller-container"
      >
        <PostsList posts={this.state.studentPosts} type={'studentPost'} userRoleInfo={this.state.userRoleInfo} onDestroyPost={this.onDestroyPost} onUntagPost={this.onUntagPost} />

        {!this.state.hasMore && this.state.studentPosts.length > 0 && <div className="no-more-scroll">没有更多新鲜事了</div>}
        {!this.state.hasMore && this.state.studentPosts.length <= 0 && <div className="no-posts">宝贝相册里还是空空的哟</div>}
      </InfiniteScroll>
    );
  }

  render() {
    return (
      <div className="student-posts-index-page">
        {this._profileHeaderView()}
        {this._postsListView()}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/StudentPostsIndexPage.jsx